import React, { useState, useCallback, useEffect, useReducer } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { confService } from '../../../Services';

import { setFilter } from '../../../redux/stores/orgSlice';

import Loader from '../../Common/Loader';
import Modal from '../../Common/Modal';

import {ReactComponent as Loading} from '../../../images/icons/General/loading-01.svg';
import {ReactComponent as Plus} from '../../../images/icons/General/plus.svg';
import {ReactComponent as Edit} from '../../../images/icons/General/edit-01.svg';
import {ReactComponent as Globe} from '../../../images/icons/Maps/globe-06.svg';
import {ReactComponent as Check} from '../../../images/icons/General/check.svg';

const dataReducer = (state, event) => {
    if (event.action === 'clear')
        return {};
    else 
        return {
            ...state,
            [event.key]: event.value
        };
};

export const DiveMode = () => {
    const [info, setInfo] = useReducer(dataReducer, {});
    const [number, setNumber] = useState(0);
    const [loading, setLoading] = useState(false);
    const [statusLoading, setStatusLoading] = useState(0);
    const [editItem, setEditItem] = useState(null);
    const [editItemKey, setEditItemKey] = useState(null);
    const [sortField, setSortField] = useState('Gear');
    const [sortOrder, setSortOrder] = useState(true);

    const sort = (e) => {
        if (e.target.id === sortField)
            setSortOrder(!sortOrder)
        else 
            setSortField(e.target.id);
    }

    const updateInfo = (item) => {
        setInfo({
            key: editItemKey, 
            value: item
        });
    }

    const fetchData = useCallback(async () => {
        setLoading(true);

        const res = await confService.getDiveModes();
        res.list.forEach((el, key) => {
            setInfo({
                key: key,
                value: el
            });
        });
        setNumber(res.number);

        setLoading(false);
      }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);
    return (
        <>
            {loading ? <Loader /> : <>
                <h1>Dive modes</h1>
                {info ? <>
                    <div className="bordered-content">
                        <div className="header">
                            <h4>{number} item{number === 1 ? '' : 's'}</h4>
                            <p>There are built-in dive modes that cannot be edited</p>
                            <div className="buttons">
                                <button className="primary" type="button" onClick={() => setEditItem({})}><Plus />Add item</button>
                            </div>
                        </div>
                        <table>
                            <thead>
                                <tr>
                                    <th style={{width: '50%'}} className={`sortable ${sortField === 'Gear' ? (sortOrder ? 'down' : 'up') : ''}`} id="Gear" onClick={sort}>Name</th>
                                    <th style={{width: '5%'}} className="light">Edit</th>  
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(info).sort(([,a],[,b]) => {
                                    if (typeof a[sortField] === 'number')
                                        return sortOrder ? a[sortField] - b[sortField] : b[sortField] - a[sortField];
                                    else {
                                        const fieldA = a[sortField].toUpperCase(); 
                                        const fieldB = b[sortField].toUpperCase();
                                        if (fieldA < fieldB)
                                            return sortOrder ? -1 : 1;

                                        if (fieldA > fieldB)
                                            return sortOrder ? 1 : -1;
                                        
                                        return 0;
                                    }
                                }).map(([key, item]) => {
                                    return (
                                        <tr key={item.GearID}>
                                            <td className={`mobile-bold ${item.omid ? '' : 'bold'}`}>{item.Gear}</td>
                                            <td className="desktop last">{item.omid ? <Edit className="pointer" onClick={() => {setEditItem(item); setEditItemKey(key)}} /> : ''}</td>
                                            <td className="mobile">
                                                {item.omid ? <label className="label link" onClick={() => {setEditItem(item); setEditItemKey(key)}}>Edit</label> : ''}
                                            </td>
                                        </tr>
                                    )}
                                )}
                            </tbody>
                        </table>
                    </div>
                    {editItem != null ? <ModalDiveMode item={editItem} setClose={() => {
                        setEditItem(null);
                        setEditItemKey(null);
                    }} updateInfo={updateInfo} /> : ''}
                </> : <p className="empty">Dive mode list is empty</p>}
            </>}
        </>
    );
};

export default DiveMode;

const ModalDiveMode = ({item, setClose, updateInfo}) => {
    const [data, setData] = useState(item);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const orgId = useSelector((state) => state.org.id);

    const changeValue = (key, value) => {
        setData({
            ...data,
            [key]: value
        })
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        
        setError('');
        setSuccess(false);
        setLoading(true);

        let message = '';

        if (!data.Gear)
            message = 'Please, enter required fields';

            if (!message) {
                const res = await (data.GearID ? confService.editDiveMode(data) : confService.addDiveMode(data));

                if (res.res === 'OK') {
                    setData({
                        ...data,
                        GearID: item.GearID || res.id,
                        omid: orgId
                    });
                    updateInfo({
                        ...data,
                        GearID: item.GearID || res.id,
                        omid: orgId
                    });
                    setSuccess(true);
                } else {
                    setError(res.error);
                }
            } else {
                setError(message);
            }
            setLoading(false);
    };

    return (
        <Modal setClose={setClose} icon={<Globe />}>
            <h4>{data.LocationID ? 'Edit' : 'Add'} dive mode</h4>
            <form onSubmit={handleSubmit}>
                <div className="form-control">
                    <label>Name</label>
                    <input type="text" name="Gear" value={data.Gear || ''} onChange={(e) => changeValue(e.target.name, e.target.value)} />
                </div>
                <div className="form-submit">
                    <div>
                        <button type="button" className="default" onClick={setClose}>Cancel</button>
                        <button type="submit" className="primary">{loading ? <Loading className="btn-loader" alt="loader" /> : ''}Save</button>
                    </div>
                    {error ? <div className="error">{error}</div> : ''}
                    {success ? <div className="success">Dive mode was successfully {data.GearID ? 'updated' : 'added'}</div> : ''}
                </div>
            </form>
        </Modal>
    )
}